import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CustomMenuItem } from '@src/app/core/types/menu-item.type';

@Component({
  selector: 'app-menu-list',
  standalone: true,
  imports: [CommonModule, RouterModule],
  templateUrl: './menu-list.component.html',
  styleUrl: './menu-list.component.scss',
})
export class MenuListComponent {
  @Input() menuItems: CustomMenuItem[] = [];
  @Input() visible: boolean = true;
  @Input() orientation: 'horizontal' | 'vertical' = 'vertical';
  @Input() showIcons: boolean = true;

  @Output() menuItemClick = new EventEmitter<CustomMenuItem>();

  hasChildren(item: CustomMenuItem): boolean {
    return !!(item.childs && item.childs.length > 0);
  }

  navigate(item: CustomMenuItem): void {
    if (this.hasChildren(item)) {
      this.menuItemClick.emit(item);
    }
  }
}
